import {
  SubscriptionEntity,
  SubscriptionsProps
} from 'src/components/SubscriptionsCard/types';
import { EntityType } from 'src/utils/enums';

export const getEntity = (
  subscription: SubscriptionsProps,
  entityType: EntityType
): SubscriptionEntity | null => {
  if (!subscription || !entityType) {
    return null;
  }

  return (
    subscription.entities?.find(
      (entity) => entity?.type?.toUpperCase() === entityType.toUpperCase()
    ) || null
  );
};
